import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { Bar, getElementsAtEvent } from "react-chartjs-2";
import { getRelatedAdjectives } from "../../../api/statistics/keyword/KeywordStatisticsAPI";
import { Chart, registerables } from "chart.js";
import { AlertErrorProp } from "../../../components/SnackbarNoti";
import { horizontalChartOptions } from "../../../util/ChartStyleUtil";
import { singleField } from "../../../util/ArrayUtil";
import { findContentFlexFilter } from "../../../api/content/ContentAPI";
import ContentListPopup from "../../../components/popup/ContentListPopup";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
Chart.register(...registerables);

type KeywordTimeProps = {
  keyword: string;
  time: number;
};

function RelatedAdjectivesChartWrapper(props: KeywordTimeProps) {
  const {t} = useTranslation(["common", "error"]);
  const [keywordData, setKeywordData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [popup, setPopup] = useState(false);
  const [sources, setSources] = useState([]);
  const [adjective, setAdjective] = useState("");
  const chartRef = useRef();
  const onClosePopup = () => {
    setPopup(false);
    setSources([]);
  };
  useEffect(() => {
    getRelatedAdjectives(props.keyword, props.time)
      .then((res) => setKeywordData(res))
      .catch(() =>
        enqueueSnackbar(t("common:load_failed_message"), AlertErrorProp as OptionsObject)
      );
  }, [props.keyword, props.time]);
  useEffect(() => {
    if (adjective.length > 0) {
      findContentFlexFilter({
        keyword: props.keyword,
        days: props.time,
        adjective: adjective,
      })
        .then((res) => setSources(res))
        .catch((err) => {
          var noti = errorNoti(err);
          enqueueSnackbar(t("error:"+noti.message), noti.option);
        });
    }
  }, [adjective]);
  const onClick = (event: any) => {
    if (
      getElementsAtEvent(chartRef.current as unknown as Chart, event).length > 0
    ) {
      const index = getElementsAtEvent(
        chartRef.current as unknown as Chart,
        event
      )[0].index;
      setPopup(true);
      var keyword = keywordData[index];
      setAdjective(keyword["keyword"]);
    }
  };
  var options = horizontalChartOptions();
  options.plugins.title.text =
    "Các tính từ liên quan đến " +
    props.keyword +
    " (" +
    props.time +
    " ngày gần nhất)";
  options.plugins.title.display = true;
  return (
    <div>
      <Bar
        data={{
          labels: singleField(keywordData, "keyword"),
          datasets: [
            {
              label: "Số lần xuất hiện",
              backgroundColor: "#48B0F7",
              data: singleField(keywordData, "count"),
            },
          ],
        }}
        onClick={onClick}
        ref={chartRef}
        options={options}
      />
      <ContentListPopup
        popup={popup}
        onClosePopup={onClosePopup}
        contents={sources}
        title={
          "Các bài báo gần đây về " + props.keyword + " có tính từ " + adjective
        }
      />
    </div>
  );
}

export default RelatedAdjectivesChartWrapper;
